import { getBreakpoint } from '@/scripts/tools/constants'

document.addEventListener('alpine:init', () => {
  Alpine.data('disclosure', ({ id, duration }) => ({      
    id,
    duration,

    get expanded() {
      return this.id === this.expandedId
    },

    toggleDisclosure() {
      if (this.expanded) {
        this.expandedId = null
      } else {
        this.expandedId = this.id
      }

      if (window.innerWidth < getBreakpoint('md')) {
        setTimeout(() => {
          this.scrollToTop();
        }, this.duration);
      }
    },

    scrollToTop() {
      const headerHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
        .trim();

      const headerHeightValue = parseInt(headerHeight, 10);

      const targetPosition = this.$el.getBoundingClientRect().top + window.scrollY - headerHeightValue;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    },
  }))
});